import React from 'react';
import { Route, Switch, withRouter, Redirect } from 'react-router-dom';
import { connect } from 'react-redux';
import { routes } from './routes';
import { permissionHelper } from '../utils';
import './router.scss';

const routeList = [...routes];

class Router extends React.Component {
  render() {
    return (
      <Switch>
        {routeList.map((route, routeIndex) => {
          if (route.permission) {
            if (permissionHelper.hasUserPermission(route.permission)) {
              return (
                <Route
                  key={routeIndex}
                  exact={!!route.exact}
                  path={route.path}
                  component={route.component}
                  {...route}
                />
              );
            }
          } else {
            return (
              <Route key={routeIndex} exact={!!route.exact} path={route.path} component={route.component} />
            );
          }
        })}
      </Switch>
    );
  }
}

const mapStateToProps = state => ({
  userPermissions:
    state.authReducer.meInfo && state.authReducer.meInfo.selectedRole
      ? state.authReducer.meInfo.selectedRole.permissions
      : []
});

export default connect(mapStateToProps)(withRouter(Router));
